import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";

import { type AnalyticsRange, fetchUserAnalytics } from "@/lib/user-analytics-api";

/** Shared by the route loader and the Overview tab, so both hit one cache entry. */
export function userAnalyticsQuery(userId: string, range: AnalyticsRange) {
  return queryOptions({
    queryKey: ["admin", "users", userId, "analytics", range] as const,
    queryFn: () => fetchUserAnalytics(userId, range),
    staleTime: 30 * 1000,
  });
}

/** Admin: the account Overview. Keeps the previous range on screen while a new one loads. */
export function useUserAnalytics(userId: string, range: AnalyticsRange) {
  return useQuery({ ...userAnalyticsQuery(userId, range), placeholderData: keepPreviousData });
}
